import React, { ComponentProps } from "react";
import ReactMarkdown, { Options } from "react-markdown";
import { CustomLink } from "./CustomLink";
import { InlineCode } from "./InlineCode";
import { LinkProps } from "@chakra-ui/react";
import { MarkdownCodeBlock } from "@apollo/chakra-helpers";

export const MarkdownRenderer = (props: Options) => {
  const mdComponents = {
    a: (props: LinkProps) => <CustomLink color="link" {...props} />,
    code: InlineCode,
    inlineCode: InlineCode,
    pre: (props: ComponentProps<typeof MarkdownCodeBlock>) => (
      <MarkdownCodeBlock isPartOfMultiCode {...props} />
    ),
  };

  return (
    <ReactMarkdown components={mdComponents} unwrapDisallowed {...props} />
  );
};
